import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../../config/jewelleryLandingConfig';

const Process = () => {
  return (
    <section id="process" className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          {/* H2 for section */}
          <h2 className="text-4xl md:text-5xl text-espresso mb-6">A Seamless, Done-For-You Process</h2>
          <div className="w-24 h-1 bg-mutedGold mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Connector line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-[1px] bg-champagne z-0"></div>

          {config.process.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="relative z-10 flex flex-col items-center text-center"
            >
              <div className="w-24 h-24 bg-ivory rounded-full flex items-center justify-center border border-mutedGold text-2xl font-serif text-espresso mb-8 shadow-sm">
                {step.step}
              </div>
              {/* H3 for each step */}
              <h3 className="text-2xl font-serif text-espresso mb-4">{step.title}</h3>
              <p className="font-light text-espresso/70 leading-relaxed max-w-sm">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;